import { render, staticRenderFns } from "./UserCerts.vue?vue&type=template&id=161be53d&scoped=true&"
import script from "./UserCerts.vue?vue&type=script&lang=js&"
export * from "./UserCerts.vue?vue&type=script&lang=js&"
import style0 from "./UserCerts.vue?vue&type=style&index=0&id=161be53d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161be53d",
  null
  
)

export default component.exports